"use client";

import { usePostStats } from "@/components/PostStatsProvider";

interface ViewCounterProps {
  viewCountLabel: string;
}

export default function ViewCounter({
  viewCountLabel,
}: ViewCounterProps) {
  const { viewCount } = usePostStats();

  return (
    <div>
      {viewCountLabel}: {viewCount !== null ? viewCount.toLocaleString() : "—"}
    </div>
  );
}
